import { queryKeys } from "../queryKeys";
import { getTaxFileForm } from "../rest/entityOnboarding";
import useRequest, { type QueryOptions } from "./useRequest";

export type EntityTaxFormKind =
  | "w_8ben"
  | "certifications_and_resolutions_statement";

export const useGetEntityTaxForm = ({
  accountId,
  ownerId,
  taxForm,
  options,
}: {
  accountId: string;
  ownerId: string;
  taxForm: EntityTaxFormKind;
  options?: QueryOptions<Blob>;
}) => {
  return useRequest(
    queryKeys.documents.entityTaxForm(accountId, ownerId, taxForm),
    () =>
      getTaxFileForm({
        accountId,
        ownerId,
        form: taxForm,
      }),
    {
      enabled: !!ownerId && !!accountId,
      ...options,
    },
  );
};
